(function initSiteHeaderMobile() {
  const searchOverlay = document.getElementById("site-search-overlay");
  const drawer = document.getElementById("site-header-drawer");
  if (!searchOverlay || !drawer) return;

  const searchToggle = document.querySelector(".site-header__search-toggle");
  const menuToggle = document.querySelector(".site-header__menu-toggle");
  const searchInput = document.getElementById("header-search-overlay");
  const drawerPanel = drawer.querySelector(".site-header__drawer-panel");
  const mqDesktop = window.matchMedia("(min-width: 769px)");
  const mqReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const DRAWER_CLOSE_FALLBACK_MS = 480;

  let drawerCloseTimer = null;
  let onDrawerTransitionEnd = null;

  function syncBodyLock() {
    const searchOpen = !searchOverlay.hasAttribute("hidden");
    const drawerOpen = !drawer.hasAttribute("hidden");
    document.body.classList.toggle("is-header-locked", searchOpen || drawerOpen);
  }

  function cancelDrawerCloseAnimation() {
    if (drawerCloseTimer) {
      clearTimeout(drawerCloseTimer);
      drawerCloseTimer = null;
    }
    if (onDrawerTransitionEnd && drawerPanel) {
      drawerPanel.removeEventListener("transitionend", onDrawerTransitionEnd);
      onDrawerTransitionEnd = null;
    }
  }

  function applyDrawerFullyClosed() {
    cancelDrawerCloseAnimation();
    drawer.classList.remove("is-open");
    drawer.setAttribute("hidden", "");
    menuToggle?.setAttribute("aria-expanded", "false");
    menuToggle?.setAttribute("aria-label", "Open menu");
    syncBodyLock();
  }

  function closeSearch() {
    searchOverlay.setAttribute("hidden", "");
    searchToggle?.setAttribute("aria-expanded", "false");
    searchToggle?.setAttribute("aria-label", "Open search");
    syncBodyLock();
  }

  function closeDrawer() {
    if (drawer.hasAttribute("hidden")) return;
    cancelDrawerCloseAnimation();

    if (mqReduceMotion.matches) {
      applyDrawerFullyClosed();
      return;
    }

    drawer.classList.remove("is-open");

    const finish = () => {
      if (drawer.hasAttribute("hidden")) return;
      if (drawerCloseTimer) {
        clearTimeout(drawerCloseTimer);
        drawerCloseTimer = null;
      }
      if (onDrawerTransitionEnd && drawerPanel) {
        drawerPanel.removeEventListener("transitionend", onDrawerTransitionEnd);
        onDrawerTransitionEnd = null;
      }
      drawer.classList.remove("is-open");
      drawer.setAttribute("hidden", "");
      menuToggle?.setAttribute("aria-expanded", "false");
      menuToggle?.setAttribute("aria-label", "Open menu");
      syncBodyLock();
    };

    if (!drawerPanel) {
      finish();
      return;
    }

    onDrawerTransitionEnd = (e) => {
      if (e.target !== drawerPanel || e.propertyName !== "transform") return;
      finish();
    };
    drawerPanel.addEventListener("transitionend", onDrawerTransitionEnd);
    drawerCloseTimer = window.setTimeout(finish, DRAWER_CLOSE_FALLBACK_MS);
  }

  function openSearch() {
    cancelDrawerCloseAnimation();
    drawer.classList.remove("is-open");
    drawer.setAttribute("hidden", "");
    menuToggle?.setAttribute("aria-expanded", "false");
    menuToggle?.setAttribute("aria-label", "Open menu");
    searchOverlay.removeAttribute("hidden");
    searchToggle?.setAttribute("aria-expanded", "true");
    searchToggle?.setAttribute("aria-label", "Close search");
    syncBodyLock();
    queueMicrotask(() => searchInput?.focus());
  }

  function openDrawer() {
    cancelDrawerCloseAnimation();
    closeSearch();
    drawer.removeAttribute("hidden");
    drawer.classList.remove("is-open");
    menuToggle?.setAttribute("aria-expanded", "true");
    menuToggle?.setAttribute("aria-label", "Close menu");
    syncBodyLock();

    if (mqReduceMotion.matches) {
      drawer.classList.add("is-open");
      return;
    }

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        drawer.classList.add("is-open");
      });
    });
  }

  searchToggle?.addEventListener("click", () => {
    if (searchOverlay.hasAttribute("hidden")) openSearch();
    else closeSearch();
  });

  menuToggle?.addEventListener("click", () => {
    if (drawer.hasAttribute("hidden")) openDrawer();
    else closeDrawer();
  });

  searchOverlay.querySelectorAll("[data-search-overlay-close]").forEach((el) => {
    el.addEventListener("click", closeSearch);
  });

  drawer.querySelectorAll("[data-drawer-close]").forEach((el) => {
    el.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (!searchOverlay.hasAttribute("hidden")) closeSearch();
    else if (!drawer.hasAttribute("hidden")) closeDrawer();
  });

  mqDesktop.addEventListener("change", (ev) => {
    if (ev.matches) {
      cancelDrawerCloseAnimation();
      drawer.classList.remove("is-open");
      drawer.setAttribute("hidden", "");
      closeSearch();
      menuToggle?.setAttribute("aria-expanded", "false");
      menuToggle?.setAttribute("aria-label", "Open menu");
      syncBodyLock();
    }
  });

  drawer.querySelectorAll(".site-header__drawer-nav-link").forEach((link) => {
    link.addEventListener("click", () => closeDrawer());
  });

  drawer.querySelectorAll(".site-header__drawer-action").forEach((link) => {
    link.addEventListener("click", () => closeDrawer());
  });
})();

(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const root = document.querySelector(".brands-section");
  const marquee = root?.querySelector(".brands-section__marquee");
  const strip = root?.querySelector(".brands-section__strip");
  if (!marquee || !strip) return;

  const applyShift = () => {
    const w = strip.offsetWidth;
    if (w < 1) return;
    marquee.style.setProperty("--marquee-shift", `${w}px`);
    marquee.classList.add("is-marquee-ready");
  };

  const ro = new ResizeObserver(() => applyShift());
  ro.observe(strip);

  strip.querySelectorAll("img").forEach((img) => {
    if (!img.complete) img.addEventListener("load", applyShift, { once: true });
  });

  const runWhenStable = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(applyShift);
    });
  };

  if (document.readyState === "complete") runWhenStable();
  else window.addEventListener("load", runWhenStable, { once: true });

  runWhenStable();
})();

(function () {
  const filterRoot = document.querySelector(".collection-filters");
  const grid = document.querySelector("#collection-product-grid");
  if (!filterRoot || !grid) return;

  const emptyEl = document.getElementById("collection-empty-state");
  const liveEl = document.getElementById("collection-results-live");

  let brand = "all";
  let priceRange = "any";
  let sort = "featured";

  const parsePrice = (li) => Number(li.getAttribute("data-price")) || 0;

  const priceMatches = (li) => {
    const p = parsePrice(li);
    switch (priceRange) {
      case "under-1000":
        return p < 1000;
      case "1000-5000":
        return p >= 1000 && p <= 5000;
      case "over-5000":
        return p > 5000;
      default:
        return true;
    }
  };

  const brandMatches = (li) => {
    if (brand === "all") return true;
    return li.getAttribute("data-vendor") === brand;
  };

  const sortItems = (items) => {
    const copy = [...items];
    copy.sort((a, b) => {
      if (sort === "featured") {
        return (
          Number(a.getAttribute("data-original-order")) -
          Number(b.getAttribute("data-original-order"))
        );
      }
      const pa = parsePrice(a);
      const pb = parsePrice(b);
      if (sort === "price-asc") return pa - pb;
      if (sort === "price-desc") return pb - pa;
      return 0;
    });
    return copy;
  };

  const applyFilters = () => {
    const items = [...grid.querySelectorAll(":scope > li")];
    const ordered = sortItems(items);
    ordered.forEach((li) => grid.appendChild(li));

    let visible = 0;
    items.forEach((li) => {
      const show = brandMatches(li) && priceMatches(li);
      li.hidden = !show;
      if (show) visible += 1;
    });

    if (emptyEl) emptyEl.hidden = visible > 0;
    if (liveEl) {
      liveEl.textContent =
        visible === 0
          ? "No products match the current filters."
          : `${visible} product${visible === 1 ? "" : "s"} shown.`;
    }
  };

  const setBrandUI = () => {
    filterRoot.querySelectorAll("[data-collection-brand]").forEach((btn) => {
      const id = btn.getAttribute("data-collection-brand");
      const on = id === brand;
      btn.classList.toggle("collection-filters__btn--active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  };

  const setPricePanelUI = () => {
    filterRoot.querySelectorAll("[data-price-range]").forEach((btn) => {
      const on = btn.getAttribute("data-price-range") === priceRange;
      btn.classList.toggle("collection-filters__panel-btn--active", on);
      btn.setAttribute("aria-checked", on ? "true" : "false");
    });
  };

  const setSortPanelUI = () => {
    filterRoot.querySelectorAll("[data-sort]").forEach((btn) => {
      const on = btn.getAttribute("data-sort") === sort;
      btn.classList.toggle("collection-filters__panel-btn--active", on);
      btn.setAttribute("aria-checked", on ? "true" : "false");
    });
  };

  const closeDropdowns = () => {
    filterRoot.querySelectorAll(".collection-filters__dropdown.is-open").forEach((wrap) => {
      wrap.classList.remove("is-open");
      const panel = wrap.querySelector(".collection-filters__panel");
      const trig = wrap.querySelector(".collection-filters__btn--dropdown");
      if (panel) panel.hidden = true;
      if (trig) trig.setAttribute("aria-expanded", "false");
    });
  };

  filterRoot.querySelectorAll(".collection-filters__dropdown").forEach((wrap) => {
    const trig = wrap.querySelector(".collection-filters__btn--dropdown");
    const panel = wrap.querySelector(".collection-filters__panel");
    if (!trig || !panel) return;

    trig.addEventListener("click", (e) => {
      e.stopPropagation();
      const wasOpen = wrap.classList.contains("is-open");
      closeDropdowns();
      if (!wasOpen) {
        wrap.classList.add("is-open");
        panel.hidden = false;
        trig.setAttribute("aria-expanded", "true");
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (filterRoot.contains(e.target)) return;
    closeDropdowns();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDropdowns();
  });

  filterRoot.querySelectorAll("[data-collection-brand]").forEach((btn) => {
    btn.addEventListener("click", () => {
      brand = btn.getAttribute("data-collection-brand") || "all";
      setBrandUI();
      applyFilters();
      closeDropdowns();
    });
  });

  filterRoot.querySelectorAll("[data-price-range]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      priceRange = btn.getAttribute("data-price-range") || "any";
      setPricePanelUI();
      applyFilters();
      closeDropdowns();
    });
  });

  filterRoot.querySelectorAll("[data-sort]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      sort = btn.getAttribute("data-sort") || "featured";
      setSortPanelUI();
      applyFilters();
      closeDropdowns();
    });
  });

  const resetBtn = filterRoot.querySelector("[data-collection-reset]");
  if (resetBtn) {
    resetBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      brand = "all";
      priceRange = "any";
      sort = "featured";
      setBrandUI();
      setPricePanelUI();
      setSortPanelUI();
      applyFilters();
      closeDropdowns();
    });
  }

  setBrandUI();
  setPricePanelUI();
  setSortPanelUI();
  applyFilters();
})();

/* PDP only: hide tab + panel when there is no body text (headings alone do not count). */
function pdpPanelHasBodyContent(panel) {
  if (!panel) return false;
  const clone = panel.cloneNode(true);
  clone.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((el) => el.remove());
  clone.querySelectorAll(".pdp-tabs__read-more").forEach((el) => el.remove());
  const text = (clone.textContent || "")
    .replace(/\u00a0/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text.length) return false;
  if (/^mfr:\s*$/i.test(text)) return false;
  return true;
}

function suppressEmptyPdpTabGroup(root, options) {
  const { tabActiveClass, allEmptyRootClass, sectionEmptyClass } = options;
  const tablist = root.querySelector('[role="tablist"]');
  if (!tablist) return;

  const tabs = [...tablist.querySelectorAll('[role="tab"]')];
  tabs.forEach((tab) => {
    const panelId = tab.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!pdpPanelHasBodyContent(panel)) {
      tab.classList.add("pdp-empty-tab");
      if (panel) panel.classList.add("pdp-empty-panel");
    }
  });

  const visible = tabs.filter((t) => !t.classList.contains("pdp-empty-tab"));
  if (visible.length === 0) {
    root.classList.add(allEmptyRootClass);
    const section = root.closest("section.pdp-detail");
    if (section && sectionEmptyClass) section.classList.add(sectionEmptyClass);
    return;
  }

  tabs.forEach((tab) => {
    tab.setAttribute("aria-selected", "false");
    tab.classList.remove(tabActiveClass);
  });
  visible.forEach((tab, i) => {
    const panelId = tab.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : null;
    const selected = i === 0;
    tab.setAttribute("aria-selected", selected ? "true" : "false");
    tab.classList.toggle(tabActiveClass, selected);
    if (panel) {
      if (selected) panel.removeAttribute("hidden");
      else panel.setAttribute("hidden", "");
    }
  });
}

/* Product detail: tabs, quantity, gallery thumbs */
(function initPdp() {
  const tablist = document.querySelector(".pdp-tabs__list");
  if (tablist && document.body.classList.contains("product-page")) {
    const buyboxTabsRoot = tablist.closest(".pdp-tabs");
    if (buyboxTabsRoot) {
      suppressEmptyPdpTabGroup(buyboxTabsRoot, {
        tabActiveClass: "pdp-tabs__tab--active",
        allEmptyRootClass: "pdp-tabs--all-empty",
        sectionEmptyClass: null,
      });
    }
  }

  const buyboxTabsRoot = tablist?.closest(".pdp-tabs");
  const skipBuyboxTabClicks =
    !tablist || !buyboxTabsRoot || buyboxTabsRoot.classList.contains("pdp-tabs--all-empty");

  if (!skipBuyboxTabClicks) {
    const tabs = [...tablist.querySelectorAll('[role="tab"]')].filter(
      (t) => !t.classList.contains("pdp-empty-tab")
    );
    const panels = tabs.map((t) => document.getElementById(t.getAttribute("aria-controls") || ""));

    function activateTab(active) {
      tabs.forEach((tab, i) => {
        const selected = tab === active;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.classList.toggle("pdp-tabs__tab--active", selected);
        const panel = panels[i];
        if (panel) {
          if (selected) panel.removeAttribute("hidden");
          else panel.setAttribute("hidden", "");
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activateTab(tab));
    });
  }

  const readMoreBtn = document.getElementById("pdp-read-more-btn");
  const readMoreText = document.getElementById("pdp-desc-text");
  const descPanel = document.getElementById("pdp-panel-desc");
  if (readMoreBtn && readMoreText) {
    function descPanelVisible() {
      return descPanel ? !descPanel.hasAttribute("hidden") : true;
    }

    function syncReadMoreButton() {
      if (!descPanelVisible()) {
        readMoreBtn.setAttribute("hidden", "");
        return;
      }
      if (readMoreText.classList.contains("is-expanded")) {
        readMoreBtn.removeAttribute("hidden");
        return;
      }
      const slack = 2;
      const needsToggle = readMoreText.scrollHeight > readMoreText.clientHeight + slack;
      if (needsToggle) readMoreBtn.removeAttribute("hidden");
      else readMoreBtn.setAttribute("hidden", "");
    }

    readMoreBtn.addEventListener("click", () => {
      const expanded = readMoreText.classList.toggle("is-expanded");
      readMoreBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
      readMoreBtn.textContent = expanded ? "Read Less" : "Read More ...";
      syncReadMoreButton();
    });

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(syncReadMoreButton);
    });
    window.addEventListener("load", syncReadMoreButton, { passive: true });

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => syncReadMoreButton());
      ro.observe(readMoreText);
    }

    if (descPanel && typeof MutationObserver !== "undefined") {
      const mo = new MutationObserver(() => syncReadMoreButton());
      mo.observe(descPanel, { attributes: true, attributeFilter: ["hidden"] });
    }
  }

  const qtyInput = document.getElementById("pdp-qty-input");
  const minus = document.getElementById("pdp-qty-minus");
  const plus = document.getElementById("pdp-qty-plus");
  if (qtyInput && minus && plus) {
    const min = () => Math.max(1, parseInt(qtyInput.min, 10) || 1);
    const max = () => Math.min(99, parseInt(qtyInput.max, 10) || 99);
    function clamp() {
      let n = parseInt(qtyInput.value, 10);
      if (Number.isNaN(n)) n = min();
      n = Math.min(max(), Math.max(min(), n));
      qtyInput.value = String(n);
    }
    minus.addEventListener("click", () => {
      let n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = String(Math.max(min(), n - 1));
    });
    plus.addEventListener("click", () => {
      let n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = String(Math.min(max(), n + 1));
    });
    qtyInput.addEventListener("change", clamp);
    qtyInput.addEventListener("blur", clamp);
  }

  const thumbsWrap = document.getElementById("pdp-gallery-thumbs");
  const mainImg = document.getElementById("pdp-main-image");
  const prevChev = document.querySelector(".pdp-gallery__chev--prev");
  const nextChev = document.querySelector(".pdp-gallery__chev--next");
  const thumbBtns = thumbsWrap ? [...thumbsWrap.querySelectorAll(".pdp-gallery__thumb")] : [];

  function setActiveThumb(btn) {
    thumbBtns.forEach((b) => {
      b.classList.toggle("pdp-gallery__thumb--active", b === btn);
      if (b === btn) b.setAttribute("aria-current", "true");
      else b.removeAttribute("aria-current");
    });
    const img = btn?.querySelector("img");
    if (mainImg && img?.src) mainImg.src = img.src;
  }

  thumbBtns.forEach((btn) => {
    btn.addEventListener("click", () => setActiveThumb(btn));
  });

  const scrollStep = 120;
  if (thumbsWrap && prevChev && nextChev) {
    prevChev.addEventListener("click", () => {
      thumbsWrap.scrollBy({ left: -scrollStep, behavior: "smooth" });
    });
    nextChev.addEventListener("click", () => {
      thumbsWrap.scrollBy({ left: scrollStep, behavior: "smooth" });
    });
  }
})();

/* PDP: pill tabs (Product Details / Features / …) */
(function initPdpDetailTabs() {
  const tablist = document.querySelector(".pdp-detail-tabs__list");
  if (!tablist) return;

  if (document.body.classList.contains("product-page")) {
    const detailTabsRoot = tablist.closest(".pdp-detail-tabs");
    if (detailTabsRoot) {
      suppressEmptyPdpTabGroup(detailTabsRoot, {
        tabActiveClass: "pdp-detail-tabs__tab--active",
        allEmptyRootClass: "pdp-detail-tabs--all-empty",
        sectionEmptyClass: "pdp-detail--tabs-empty",
      });
    }
  }

  if (tablist.closest(".pdp-detail-tabs--all-empty")) return;

  const tabs = [...tablist.querySelectorAll('[role="tab"]')].filter(
    (t) => !t.classList.contains("pdp-empty-tab")
  );
  if (!tabs.length) return;

  const panels = tabs.map((t) => document.getElementById(t.getAttribute("aria-controls") || ""));

  function activateTab(active) {
    tabs.forEach((tab, i) => {
      const selected = tab === active;
      tab.setAttribute("aria-selected", selected ? "true" : "false");
      tab.classList.toggle("pdp-detail-tabs__tab--active", selected);
      const panel = panels[i];
      if (panel) {
        if (selected) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      }
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => activateTab(tab));
  });
})();

/* PDP: bundle helpers (exclude rows, totals, add-to-cart) */
const fiboPdpBundle = {
  getMainVariantIdFromForm() {
    const form = document.querySelector('.pdp-buybox form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form) return null;
    const input = form.querySelector('input[name="id"]');
    if (!input || !input.value) return null;
    const id = parseInt(input.value, 10);
    return Number.isFinite(id) ? id : null;
  },

  collectItems(root) {
    const items = [];
    const seen = new Set();

    function pushId(id) {
      if (!id || seen.has(id)) return;
      seen.add(id);
      items.push({ id, quantity: 1 });
    }

    if (root.dataset.mainAvailable === "true") {
      const mainId = fiboPdpBundle.getMainVariantIdFromForm() || parseInt(root.dataset.mainVariantId || "", 10);
      if (Number.isFinite(mainId)) pushId(mainId);
    }

    root.querySelectorAll("[data-bundle-item][data-variant-id]").forEach((el) => {
      if (el.closest(".pdp-bundle__card--excluded")) return;
      const id = parseInt(el.getAttribute("data-variant-id") || "", 10);
      if (Number.isFinite(id)) pushId(id);
    });

    return items;
  },

  formatMoneyCents(cents, currencyCode) {
    const c = currencyCode || "USD";
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: c }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  },

  computeTotalCents(root) {
    let sum = 0;
    root.querySelectorAll(".pdp-bundle__card[data-line-cents]").forEach((card) => {
      if (card.classList.contains("pdp-bundle__card--excluded")) return;
      const n = parseInt(card.getAttribute("data-line-cents") || "0", 10);
      if (Number.isFinite(n)) sum += n;
    });
    if (root.dataset.mainAvailable === "true") {
      const m = parseInt(root.dataset.mainVariantCents || "0", 10);
      if (Number.isFinite(m)) sum += m;
    }
    return sum;
  },

  syncChrome(root) {
    const totalEl = root.querySelector("[data-bundle-total-value]");
    if (totalEl) {
      totalEl.textContent = fiboPdpBundle.formatMoneyCents(
        fiboPdpBundle.computeTotalCents(root),
        root.dataset.currencyCode
      );
    }
    const addBtn = root.querySelector("[data-bundle-add-all]");
    if (addBtn) {
      addBtn.disabled = fiboPdpBundle.collectItems(root).length === 0;
    }
  },
};

(function syncBundleRootsOnReady() {
  function run() {
    document.querySelectorAll("[data-bundle-root]").forEach((root) => fiboPdpBundle.syncChrome(root));
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();

document.body.addEventListener("click", (e) => {
  const rm = e.target.closest("[data-bundle-remove]");
  if (!rm) return;
  const card = rm.closest(".pdp-bundle__card");
  const root = rm.closest("[data-bundle-root]");
  if (!card || !root) return;
  e.preventDefault();
  const excluded = card.classList.toggle("pdp-bundle__card--excluded");
  rm.setAttribute("aria-pressed", excluded ? "true" : "false");
  const removeL = root.dataset.bundleRemoveLabel || "Remove from bundle";
  const restoreL = root.dataset.bundleRestoreLabel || "Add back to bundle";
  rm.setAttribute("aria-label", excluded ? restoreL : removeL);
  fiboPdpBundle.syncChrome(root);
});

/* PDP: add bundle products to cart (Cart API — event delegation + batch / sequential fallback) */
(function initPdpBundleAddAll() {
  function getCartAddJsUrl() {
    const raw = (window.routes && window.routes.cart_add_url) || "/cart/add";
    const path = String(raw).trim().split("?")[0];
    const base = path.replace(/\.js$/i, "");
    return `${base}.js`;
  }

  function hideError(root) {
    const errEl = root.querySelector("[data-bundle-error]");
    if (!errEl) return;
    errEl.textContent = "";
    errEl.setAttribute("hidden", "");
  }

  function showError(root, msg) {
    const errEl = root.querySelector("[data-bundle-error]");
    if (errEl) {
      errEl.textContent = msg;
      errEl.removeAttribute("hidden");
    } else if (msg) {
      window.alert(msg);
    }
  }

  async function postCartItems(items) {
    const url = getCartAddJsUrl();
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
      credentials: "same-origin",
    });
    const data = await res.json().catch(() => ({}));
    return { res, data };
  }

  function errorMessage(data) {
    return (
      (typeof data.description === "string" && data.description) ||
      (typeof data.message === "string" && data.message) ||
      "Could not add bundle to cart."
    );
  }

  document.body.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-bundle-add-all]");
    if (!btn || btn.disabled) return;
    const root = btn.closest("[data-bundle-root]");
    if (!root) return;

    hideError(root);
    const items = fiboPdpBundle.collectItems(root);
    if (!items.length) {
      showError(root, "No items available to add.");
      return;
    }

    btn.classList.add("is-loading");
    btn.setAttribute("aria-busy", "true");

    try {
      let { res, data } = await postCartItems(items);
      let cartPayload = data;

      if (!res.ok && items.length > 1) {
        let lastData = data;
        let lastCart = null;
        let allOk = true;
        for (let i = 0; i < items.length; i++) {
          const line = items[i];
          const one = await postCartItems([line]);
          if (!one.res.ok) {
            allOk = false;
            lastData = one.data;
            break;
          }
          lastCart = one.data;
        }
        if (allOk && lastCart) {
          res = { ok: true };
          cartPayload = lastCart;
        } else if (!allOk) {
          showError(root, errorMessage(lastData));
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "pdp-bundle",
              errors: lastData.errors || lastData.description,
              message: lastData.message,
            });
          }
          return;
        }
      }

      if (!res.ok) {
        showError(root, errorMessage(cartPayload));
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "pdp-bundle",
            errors: cartPayload.errors || cartPayload.description,
            message: cartPayload.message,
          });
        }
        return;
      }

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "pdp-bundle", cartData: cartPayload });
      }

      if (root.dataset.openDrawer === "true") {
        const drawer = document.querySelector("cart-drawer");
        if (drawer && typeof drawer.open === "function") {
          const trigger =
            document.querySelector("#cart-icon-bubble") || document.querySelector(".site-header__action--cart");
          window.setTimeout(() => drawer.open(trigger || undefined), 250);
        }
      }
    } catch (err) {
      showError(root, "Could not add bundle to cart.");
    } finally {
      btn.classList.remove("is-loading");
      btn.removeAttribute("aria-busy");
    }
  });
})();
